angular.module('picmonicpublic')
    .factory("PresentationsResource", ['$resource', function($resource){
        return $resource("/api/v3/presentations/:presentation_id/:resource", {presentation_id:'@presentation_id', resource:'@resource'}, {
        });
    }]);